<template>
	<div class="bond-event-block">
		<h1 style="margin-top:0;">Bond Events</h1>
		<el-table ref="bond_event_table" :data="bond_events" border @row-click="expansionHandler">
			<el-table-column type="expand" width="24px">
				<template slot-scope="props">
					<key-value-list>
						<key-value-item label="Charge Details" :value="props.row.ChargeDetails.split(';')"></key-value-item>
						<key-value-item label="Prosecutor" :value="props.row.Prosecutor"></key-value-item>
						<key-value-item label="Judge" :value="props.row.Judge || 'unspecified'"></key-value-item>
						<key-value-item label="Defense Attorney" :value="props.row.DefenseAttorney"></key-value-item>
					</key-value-list>
				</template>
			</el-table-column>

			<el-table-column prop="DefendantFullName" label="Defendant" min-width="65px"></el-table-column>
			<el-table-column prop="EventDescription" label="Event Description" min-width="100px"></el-table-column>
			<el-table-column prop="ArrestDate" label="Arrest Date"  width="100px"></el-table-column>
			<el-table-column prop="Status" label="Status" width="70px"></el-table-column>

			<el-table-column prop="EventDate" label="Event Date" width="100px"></el-table-column>

			<el-table-column prop="Jurisdiction" label="Jurisdiction" width="95px"></el-table-column>

			<!-- <el-table-column prop="EventDescription" label="Event Description" min-width="110px"></el-table-column>
			<el-table-column prop="Prosecutor" label="Prosecutor"></el-table-column>
			<el-table-column prop="Judge" label="Judge"></el-table-column>
			<el-table-column prop="DefenseAttorney" label="Defense Attorney"></el-table-column> -->


		</el-table>
	</div>
</template>

<script>
export default{
	props: ['bond_events'],
	methods:{
		expansionHandler(row){
			this.$refs.bond_event_table.toggleRowExpansion(row);
		}
	}
}
</script>

<style scoped>
>>> .key-value-item{
	display:flex;
}
>>> .key-value-item__label{
	width:160px;
}
>>> .key-value-item__value{
	flex-grow:1;
	text-align:left !important;
}
>>> .el-table__body, >>> .el-table__header{
	min-width:600px;
	width:100% !important;
}
>>> th{
	background-color:#359DB4;
	color:white;
	border-color: #359DB4;
}
h1{
	text-align: center;
}
>>> .cell{
	font-family:'News Cycle';
	word-break: normal !important;
}
>>> td{
	padding:5px 0;
}
>>> .el-table__row{
	cursor:pointer;
}
>>> tr > td:first-child .cell{
	padding:0;
}
>>> .el-table__expanded-cell{
	padding:12px 32px;
}

>>> .el-table th{
	padding: 5px 0;
}

>>> .el-table--group, .el-table--border{
	box-shadow: 0 2px 4px rgba(0,0,0,.25);
	border-radius: .25rem;
	overflow: hidden;
}

/* >>> .el-table, >>> .el-table th, >>> .el-table tr{
background:transparent;
background-color:transparent;
} */
.bond-event-block{
	padding:10px;
	color: #474554;

	height:100%;
	line-height:1;
	flex-shrink:0;
}
>>> .el-table .cell{
	letter-spacing:0;
}
@media(max-width:800px){
	.bond-event-block{
		padding:10px 0 !important;
	}
}
</style>
